// src/modules/settings/constants/settingsDefaults.ts
import { SeverityCVEMapping, SplashtopRemoteAccessSettings } from '../../../components/services/TenantSettingsService';

/**
 * Default values for Defatom Agent Settings
 */
export const DEFAULT_DEFATOM_AGENT_SETTINGS = {
  numberOfDaysForIdentifyingDisconncetedEndpoint: 30,
  maxEndpointDisconnectedThresholdInDays: 90,
  thresholdInMinutesForTaggingAgentAsOffline: 30,
  thresholdInMinutesForTaggingAgentAsOfflineForRemediationPlan: 60,
  useVendorPackageRepoAsPrimary: true,
};

/**
 * Splashtop settings written only when remote access is switched on for a tenant whose featureList has no Splashtop
 * entry yet. featureList is an array, so nothing is inherited from the global list: the entry has to be complete.
 * An existing entry is never replaced; only its "enabled" flag changes.
 */
export const DEFAULT_SPLASHTOP_SETTINGS: SplashtopRemoteAccessSettings = {
  enabled: false,
  installMode: 'eager',
  groupIds: [],
  requestPermission: 0,
  hideTrayIcon: true,
  idleTimeoutMinutes: 0,
  clientType: 'app',
  permissions: {
    file_transfer: 1,
    copy_paste: 1,
    remote_print: 0,
    keystroke: 1,
    task_manager: 1,
    service_manager: 1,
    registry_editor: 0,
    device_manager: 1,
  },
  notificationMode: 3,
  allowCloseBanner: 0,
};

/**
 * Default values for Remediation Settings
 */
export const DEFAULT_REMEDIATION_SETTINGS = {
  numberOfSoftwareVersionsAvailableForRemediation: 3,
};

/**
 * Default values for Compliance Settings
 */
export const DEFAULT_COMPLIANCE_SETTINGS = {
  currentPreviousDurationInDays: 30,
  nonComplainceDefinitionDays: 30,
};

/**
 * Default CVE Score Mapping
 */
export const DEFAULT_CVE_MAPPING: SeverityCVEMapping[] = [
  { severity: 'Critical', cveScore: '>8' },
  { severity: 'High', cveScore: '4-8' },
  { severity: 'Medium', cveScore: '1-4' },
  { severity: 'Low', cveScore: '<1' },
];

/**
 * Default Days Range Configuration
 */
export const DEFAULT_DAYS_RANGE: string[] = ['>90', '61-90', '31-60', '<31'];

/**
 * Validation limits for settings fields
 */
export const VALIDATION_LIMITS = {
  days: { min: 1, max: 365 },
  minutes: { min: 1, max: 1440 },
  softwareVersions: { min: 1, max: 10 },
};
